module.exports = __webpack_public_path__ + "img/car.4f98f6d6.png";